(() => {
  const ROOT_SELECTOR = '#th_wishlist_page_id';
  const typeCache = new Map();

  const parseMoney = (value) => {
    const numeric = String(value || '').replace(/[^\d.]/g, '');
    return numeric ? Number(numeric) : 0;
  };

  const productHandle = (card) => {
    const link = card.querySelector('.th-wl-product-title a, figure a');
    if (!link || !link.getAttribute('href')) return '';
    const match = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  };

  const enhancePrice = (card) => {
    const priceBox = card.querySelector('.th-wl-product-price-containor');
    if (!priceBox || priceBox.querySelector('.gh-wl-discount')) return;

    const priceEl = priceBox.querySelector('.th-wl-product-price');
    const compareEl = priceBox.querySelector('.th_compare_price');
    if (!priceEl || !compareEl) return;

    const price = parseMoney(priceEl.textContent);
    const compare = parseMoney(compareEl.textContent);
    if (!(compare > price) || price <= 0) return;

    const percent = Math.round((1 - price / compare) * 100);
    if (percent <= 0) return;

    const discount = document.createElement('span');
    discount.className = 'gh-wl-discount';
    discount.textContent = `${percent}% OFF`;
    priceBox.appendChild(discount);
  };

  const enhanceType = (card) => {
    if (card.querySelector('.gh-wl-type')) return;
    const handle = productHandle(card);
    if (!handle) return;

    const title = card.querySelector('.th-wl-product-title');
    if (!title) return;

    const applyType = (type) => {
      if (!type || card.querySelector('.gh-wl-type')) return;
      const label = document.createElement('div');
      label.className = 'gh-wl-type';
      label.textContent = type;
      title.parentNode.insertBefore(label, title);
    };

    if (typeCache.has(handle)) {
      applyType(typeCache.get(handle));
      return;
    }

    fetch(`/products/${handle}.js`)
      .then((response) => (response.ok ? response.json() : null))
      .then((product) => {
        const type = product && product.type ? String(product.type).trim() : '';
        typeCache.set(handle, type);
        applyType(type);
      })
      .catch(() => {
        typeCache.set(handle, '');
      });
  };

  const EMPTY_HEART = `
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M12 21s-6.72-4.24-9.33-8.22C.7 9.7 1.66 6.12 4.78 4.84 6.82 4 9.14 4.66 12 7.05c2.86-2.39 5.18-3.05 7.22-2.21 3.12 1.28 4.08 4.86 2.11 7.94C18.72 16.76 12 21 12 21z" stroke="#e96c23" stroke-width="1.6" stroke-linejoin="round"/>
    </svg>
  `;

  const enhanceEmpty = (root) => {
    const empty = root.querySelector('.th-wl-no-wishlist');
    const hasProducts = root.querySelector('.th-wl-product-item, .th-wl-product-list-row');

    if (!empty || hasProducts) {
      root.classList.remove('gh-wl-is-empty');
      return;
    }

    root.classList.add('gh-wl-is-empty');
    if (empty.dataset.ghEmpty === '1') return;
    empty.dataset.ghEmpty = '1';

    const container = empty.closest('.th-wl-container') || root;
    const header = container.querySelector('.th-wl-container-header');
    const loginNote = header ? header.querySelector('p') : null;

    if (!container.querySelector('.gh-wl-empty-icon')) {
      const icon = document.createElement('div');
      icon.className = 'gh-wl-empty-icon';
      icon.innerHTML = EMPTY_HEART;
      container.insertBefore(icon, empty);
    }

    if (loginNote) {
      loginNote.classList.add('gh-wl-empty-note');
      empty.insertAdjacentElement('afterend', loginNote);
    }

    if (!container.querySelector('.gh-wl-empty-cta')) {
      const cta = document.createElement('a');
      cta.className = 'gh-wl-empty-cta';
      cta.href = '/';
      cta.textContent = 'Continue shopping';
      container.appendChild(cta);
    }
  };

  const hideAddAll = (root) => {
    root.querySelectorAll('.tab-content').forEach((panel) => {
      if (panel.style.getPropertyPriority('display') === 'important') {
        panel.style.removeProperty('display');
      }
    });

    root.querySelectorAll('.add-to-cart-all-product, .add-to-cart-all-product-btn').forEach((el) => {
      el.style.setProperty('display', 'none', 'important');
    });

    root.querySelectorAll('input[type="checkbox"]').forEach((input) => {
      const host = input.closest('label') || input.parentElement;
      const text = ((host && host.textContent) || '').replace(/\s+/g, ' ').toLowerCase();
      if (!text.includes('remove all existing items from your cart')) return;
      if (!host || host.closest('.tab-content') === host) return;
      if (host.querySelector('.th-wl-product-item, .th-wl-product-row, .th-wl-product-list')) return;
      input.style.setProperty('display', 'none', 'important');
      host.style.setProperty('display', 'none', 'important');
    });
  };

  const enhance = (root) => {
    enhanceEmpty(root);
    hideAddAll(root);
    root.querySelectorAll('.th-wl-product-item, .th-wl-product-list-row').forEach((card) => {
      enhancePrice(card);
      enhanceType(card);
    });
  };

  const boot = () => {
    const root = document.querySelector(ROOT_SELECTOR);
    if (!root) return;

    document.body.classList.add('template--wishlist');
    enhance(root);

    const observer = new MutationObserver(() => enhance(root));
    observer.observe(root, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
